import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  IconButton,
  Tooltip,
  Button
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  FileDownload as ExportIcon,
  FilterList as FilterIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import LogsTable from '../../components/Logs/LogsTable';
import LogsFilter from '../../components/Logs/LogsFilter';
import { listLogs, exportLogs } from '../../services/logService';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const LogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState({
    tipoLog: '',
    nivelSensibilidade: '',
    dataInicio: '',
    dataFim: '',
    acao: '',
    entidade: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const response = await listLogs(filtros);
      console.log('Resposta dos logs:', response.data);
  
      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        setLogs(response.data.data);
      } else {
        console.error('Estrutura de dados inesperada:', response.data);
        setLogs([]);
      }
    } catch (error) {
      console.error('Erro detalhado ao buscar logs:', error);
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleExport = async () => {
    try {
      await exportLogs(filtros);
    } catch (error) {
      console.error('Erro ao exportar logs:', error);
    }
  };

  const handleFilterChange = (newFiltros) => {
    setFiltros(newFiltros);
  };

  return (
    <Container maxWidth="xl">
      <Box py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h4">Logs do Sistema</Typography>
              <Box display="flex" alignItems="center" gap={2}>
                <Button
                  variant="contained"
                  startIcon={<DashboardIcon />}
                  onClick={() => navigate('/dashboard')}
                >
                  Voltar ao Dashboard
                </Button>
                <Tooltip title="Atualizar">
                  <IconButton onClick={fetchLogs} disabled={loading}>
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
                {user.perfilAdmin === 'SUPER_ADMIN' && (
                  <Tooltip title="Exportar">
                    <IconButton onClick={handleExport} disabled={loading}>
                      <ExportIcon />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Filtros">
                  <IconButton onClick={() => setShowFilters(!showFilters)}>
                    <FilterIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </Grid>

          {showFilters && (
            <Grid item xs={12}>
              <Paper sx={{ p: 2 }}>
                <LogsFilter 
                  filtros={filtros}
                  onChange={handleFilterChange}
                  onApply={fetchLogs}
                />
              </Paper>
            </Grid>
          )}

          <Grid item xs={12}>
            <LogsTable 
              logs={logs}
              loading={loading}
              onDetailsClick={(log) => {/* Implementar visualização detalhada */}}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default LogsPage;
